import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ReferenceGroupItem' })((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 20,
        borderBottom: '2px solid #F5F5F5'
    },
    title: {
        cursor: 'pointer',
        textDecoration: 'none'
    },
    titleBlock: {
        display: 'flex',
        alignItems: 'center',
        flex: 1
    },
    chip: {
        background: '#F5F5F5',
        borderRadius: 8,
        marginLeft: 12
    },
    label: {
        color: '#979797'
    },
    icon: {
        border: '1px solid #EEEEEE',
        color: theme.palette.primary.main
    }
}));
